import React from "react";
import { Box, Heading, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import Section from "./Section";
import { clients, suppliers } from "../data/content";

function NameCard({ name, emphasis }) {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor={emphasis ? "brand.300" : "ink.100"}
      borderRadius="lg"
      px={6}
      py={emphasis ? 8 : 6}
      textAlign="center"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH={emphasis ? "110px" : "88px"}
      transition="box-shadow 0.2s"
      _hover={{ boxShadow: "sm" }}
    >
      <Text fontWeight={600} fontSize={emphasis ? "lg" : "md"} color="ink.700">
        {name}
      </Text>
    </Box>
  );
}

export default function Partners() {
  return (
    <Section
      id="partners"
      bg="ink.50"
      title="Clients & Partners"
      subtitle="Trusted by Omani industry and backed by established international suppliers."
    >
      <VStack spacing={14} align="stretch">
        <Box>
          <Heading
            as="h3"
            fontSize="sm"
            textTransform="uppercase"
            letterSpacing="0.1em"
            color="ink.500"
            textAlign="center"
            mb={6}
          >
            Our Clients
          </Heading>
          {/* Columns follow the client count so a single client stays centred
              rather than sitting in the left half of a two-column grid. */}
          <SimpleGrid
            columns={{ base: 1, md: Math.min(clients.length, 2) }}
            spacing={4}
            maxW={clients.length === 1 ? "md" : "2xl"}
            mx="auto"
          >
            {clients.map((client) => (
              <NameCard key={client} name={client} emphasis />
            ))}
          </SimpleGrid>
        </Box>

        <Box>
          <Heading
            as="h3"
            fontSize="sm"
            textTransform="uppercase"
            letterSpacing="0.1em"
            color="ink.500"
            textAlign="center"
            mb={6}
          >
            Our Suppliers
          </Heading>
          <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
            {suppliers.map((supplier) => (
              <NameCard key={supplier} name={supplier} />
            ))}
          </SimpleGrid>
        </Box>
      </VStack>
    </Section>
  );
}
